(function() {
  'use strict';
  
  angular.module('ringbaPortal').directive('changelogInfiniteScroll', changelogInfiniteScroll);
  
  function changelogInfiniteScroll(
    $timeout,
    $window
  ) {
    'ngInject';

    const directive = {
      restrict: 'A',
      link: link
    };

    return directive;

    function link(scope, element, attrs) {
      const raw = element[0];
      const fixedTitleElement = element.find('.changelog-fixed-title');
      let fixedElementOffset,
        heightIncludingMargin;

      init();
      scope.$on('$destroy', onDestroy);

      function init() {
        element.bind('scroll', handleScroll);

        $timeout(function () {
          heightIncludingMargin = fixedTitleElement.outerHeight(true);
          _handleDateTitleChange();
        }, 0);
      }

      function handleScroll() {
        if(raw.scrollTop + raw.offsetHeight + 5 >= raw.scrollHeight){
          scope.$apply(attrs.changelogInfiniteScroll);
        }

        _handleDateTitleChange();
      }

      function _handleDateTitleChange() {
        fixedElementOffset = fixedTitleElement.offset();
        const changeLogEntryElement = document.elementFromPoint(fixedElementOffset.left - $window.scrollX, (fixedElementOffset.top + heightIncludingMargin + 10) - $window.scrollY);
        _findAndChangeDateTitle(changeLogEntryElement);
      }

      function _findAndChangeDateTitle(changeLogEntryElement) {
        if (changeLogEntryElement && !$(changeLogEntryElement).hasClass('changelog-date-title')) {
          const dateTitle = $(changeLogEntryElement).closest('.changelog-list-items').find('.changelog-date-title');

          // Change element only if text is different
          if (dateTitle.length && fixedTitleElement[0].textContent !== dateTitle[0].textContent) {
            _changeTitleText(dateTitle[0].textContent);
            _changeZIndex(parseInt(dateTitle[0].style.zIndex) + 1);
          }
        }
      }

      function _changeTitleText(text) {
        fixedTitleElement.text(text);
      }

      function _changeZIndex(zindex) {
        fixedTitleElement.css('z-index', zindex);
      }

      function onDestroy() {
        element.unbind('scroll', handleScroll);
      }


    }
  }
})();